import * as React from 'react'
import { ifElse } from '../../utilities'
import { RainbowText } from '../RainbowText'
import styles from './styles.module.scss'
import TwoColumn from '../TwoColumn'
import classNames from 'classnames'

type Props = React.PropsWithChildren<{
  className?: string
  containerClassName?: string
  iconContainerClassName?: string
  contentContainerClassName?: string
  icon?: React.ReactNode
  title?: string | React.ReactNode
  id?: string
}>

const Section: React.FC<Props> = ({ id, className, containerClassName, iconContainerClassName, contentContainerClassName, icon, title, children }) => {
  return (
    <div className={classNames(styles.container, className)}>
      {ifElse(id, <div id={id} />)}
      <div className={classNames('container', containerClassName)}>
        <TwoColumn auto center noGap={!icon}>
          <div className={classNames(styles.iconContainer, iconContainerClassName)}>{icon}</div>
          <div className={classNames(styles.contentContainer, contentContainerClassName)}>
            {ifElse(
              typeof title === 'string',
              <div className={styles.title}>
                <RainbowText text={title} />
              </div>,
              title,
            )}
            {children}
          </div>
        </TwoColumn>
      </div>
    </div>
  )
}

export default Section
